
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import { toTitleCase, prettyDateTime } from '../../global/functions/util'
import { CustomerInvoice } from '../../global/models'

@Component({
  components: { ListComponent }
})
export default class CustomerInvoiceListPage extends Vue {
  get filterOptions() {
    return [
      { text: 'Invoice Number', key: 'invoiceNumber', type: 'string' },
      { text: 'Customer Name', key: 'customerName', type: 'string' },
      {
        text: 'Status',
        key: 'status',
        type: 'enum',
        options: [
          { text: 'Paid', value: 'paid' },
          { text: 'Refunded', value: 'refunded' }
        ]
      },
      { text: 'ID', key: 'id', type: 'number' },
      { text: 'Reference', key: 'reference', type: 'string' }
    ]
  }

  get availableColumns() {
    return [
      { text: 'Job #', value: 'jobId' },
      { text: 'Status', value: 'status', display: toTitleCase },
      { text: 'Invoice Type', value: 'type', display: toTitleCase },
      { text: 'Invoice Number', value: 'invoiceNumber' },
      { text: 'Customer Name', value: 'customerName' },
      { text: 'Reference', value: 'reference', sortable: false },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get defaultColumns() {
    return ['jobId', 'type', 'invoiceNumber', 'customerName', 'created', 'updated']
  }

  get actions() {
    return [
      { text: 'View', method: this.renderItem }
    ]
  }

  renderItem(item: CustomerInvoice) {
    this.$router.push({ name: 'customer-invoices-read', params: { id: item.id.toString() } })
  }
}
